import { Collapse, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { masterNames } from "assets/properties/properties";
import brandTheme from "brandTheme/Theme";
import classNames from "classnames";
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles(({ theme }) => ({
  itemIcon: {
    width: "24px",
    height: "30px",
    fontSize: "24px",
    lineHeight: "30px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: brandTheme.black,
  },
  itemText: {
    fontFamily: brandTheme.font.poppins,
    fontWeight: "bold",
    margin: "0",
    lineHeight: "16px",
    fontSize: "14px",
    color: brandTheme.black,
  },
  dashboardMenu1: {
    backgroundColor: brandTheme.sideBarColor,
    fontWeight: "bold",
    fontFamily: brandTheme.font.poppins,
    fontSize: "18px",
    marginBottom: "8px",
    paddingLeft:"42px",
    width:"auto",
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  children1:{
    '& $activeClass':{
      paddingLeft:54,
    },
    '& $item':{
      paddingLeft:54,
    }
  }
}));
function CollapsiblePanelChild({ children, ...props }) {
  const { collapse, subOption, secondHandle } = props;
  const [isCollapse, setIsCollapse] = useState(collapse);
  const classes = useStyles();

  const animate = collapse => {
    setIsCollapse(collapse);
  };

  useEffect(() => {
    animate(!collapse);
  }, [collapse]);

  const handleClick = (item) => {
        setIsCollapse(!isCollapse)
  }
  return (
    <div key={subOption.name}>
      <ListItem
        className={subOption?.name === masterNames?.insuranceMaster || subOption?.name === masterNames?.coLendingMaster ? classes.dashbordMenu :classes.dashboardMenu1}
        button
        onClick={() => handleClick(subOption.name)}
      >
        {typeof subOption.icon === "string" ? (
         <img src={subOption.icon} alt={""} className={classNames(classes.itemIcon)}></img>
        ) : (
          <subOption.icon className={classNames(classes.itemIcon)} />
        )}
        <ListItemText primary={subOption.name} disableTypography={true} className={classNames(classes.itemText)}/>
        {isCollapse ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isCollapse} timeout="auto" mountOnExit className={classes.children1} orientation="horizontal"> 
          {secondHandle(subOption.children)}
      </Collapse>
    </div>
  );
}

CollapsiblePanelChild.defaultProps = {
  children: "Add node as a child",
  title: "Collapsible Panel",
  collapse: true
};

export default CollapsiblePanelChild;